import {
  PRICING_TYPES,
  SERVICE_POINT_STATUSES,
  SERVICE_POINTS_PAGE_SIZE,
} from '@constants';
import { generateShortId } from '@utils';

export const VEHICLES_PAGE_SIZE = 100;

export const DEFAULT_LOCATIONS = [
  {
    text: 'instacar Pigasou',
    value: 'instacar-pigasou',
    label: 'instacar Pigasou',
  },
  // { text: 'New Way', value: 'new-way', label: 'New Way' },
  // { text: 'Zotalis', value: 'zotalis', label: 'Zotalis' },
  { text: 'Kineo', value: 'kineo', label: 'Kineo' },
  {
    text: 'instacar Employee',
    value: 'instacar-employee',
    label: 'instacar Employee',
  },
  {
    text: 'Thessaloniki Cars Airport',
    value: 'thessaloniki-cars-airport',
    label: 'Thessaloniki Cars Airport',
  },
  {
    text: 'Seat Velmar Gerakas',
    value: 'seat-velmar-gerakas',
    label: 'Seat Velmar Gerakas',
  },
  {
    text: 'Ford Velmar Marousi',
    value: 'ford-velmar-marousi',
    label: 'Ford Velmar Marousi',
  },
  { text: 'Mermigas', value: 'mermigas', label: 'Mermigas' },
  { text: 'Avance', value: 'avance', label: 'Avance' },
  {
    text: 'mazda metamorfosi',
    value: 'mazda-metamorfosi',
    label: 'mazda metamorfosi',
  },
  { text: 'Liapatis Dafni', value: 'liapatis-dafni', label: 'Liapatis Dafni' },
  {
    text: 'Koutsalaras Patra',
    value: 'koutsalaras-patra',
    label: 'Koutsalaras Patra',
  },
  {
    text: 'Kostoglou Konstantinos',
    value: 'kostoglou-konstantinos',
    label: 'Kostoglou Konstantinos',
  },
  {
    text: 'Autoone Service',
    value: 'autoone-service',
    label: 'Autoone Service',
  },
  {
    text: 'Autofix Mykonos',
    value: 'autofix-mykonos',
    label: 'Autofix Mykonos',
  },
  // TODO: maybe need to be removed
  { text: 'instacar HQ', value: 'instacar-hq', label: 'instacar HQ' },
  {
    text: 'instacar Άνοιξη',
    value: 'instacar-anoixh',
    label: 'instacar Άνοιξη',
  },
  {
    text: 'instacar Αργυρούπολη',
    value: 'instacar-argyroupoli',
    label: 'instacar Αργυρούπολη',
  },
  {
    text: "Customer's Location",
    value: 'customers-location',
    label: "Customer's Location",
  },
];

export const SERVICE_POINTS_QUERY_PAYLOAD = {
  page: 1,
  pageSize: SERVICE_POINTS_PAGE_SIZE,
  type: 0,
  field: null,
  operator: null,
  value: [
    {
      field: 'status',
      operator: 0,
      type: 5,
      value: SERVICE_POINT_STATUSES.active, // fetch only acticated
    },
  ],
};

export const VEHICLE_FINANCING_TYPES = [
  { text: 'Bank Loan 18M', value: 'Bank Loan 18M' },
  { text: 'Bank Loan 36M', value: 'Bank Loan 36M' },
  { text: 'Bank Loan 48M', value: 'Bank Loan 48M' },
  { text: 'Bond Loan', value: 'Bond Loan' },
  { text: 'Finance Lease 24M', value: 'Finance Lease 24M' },
  { text: 'Finance Lease 36M', value: 'Finance Lease 36M' },
  { text: 'Finance Lease 48M', value: 'Finance Lease 48M' },
  { text: 'Operating Lease 6M', value: 'Operating Lease 6M' },
  { text: 'Operating Lease 12M', value: 'Operating Lease 12M' },
  { text: 'Operating Lease 24M', value: 'Operating Lease 24M' },
  { text: 'Operating Lease 36M', value: 'Operating Lease 36M' },
  { text: 'Operating Lease 48M', value: 'Operating Lease 48M' },
];

export const VEHICLE_OWNERSHIPS = [
  { text: 'Instacar', value: 'Instacar' },
  { text: 'Instachr', value: 'Instachr' },
  { text: 'Instapath', value: 'Instapath' },
  { text: 'Motorlease', value: 'Motorlease' },
  { text: 'NBG Leasing', value: 'NBG Leasing' },
  { text: 'Karenta', value: 'Karenta' },
  { text: 'Eurobank Leasing VGC', value: 'Eurobank Leasing VGC' },
  { text: 'Πειραιώς Leasing', value: 'Πειραιώς Leasing' },
  { text: 'Autobesikos', value: 'Autobesikos' },
  { text: 'Hertz/Autohellas', value: 'Hertz/Autohellas' },
  { text: 'Kinsen', value: 'Kinsen' },
  { text: 'EKKA', value: 'EKKA' },
  { text: 'Avance', value: 'Avance' },
  { text: 'Instacar/Hertz', value: 'Instacar/Hertz' },
];
export const VEHICLE_DEFAULT_PRICING = [
  {
    id: generateShortId(),
    type: PRICING_TYPES.open,
    monthsDuration: null,
    signUpFee: null,
    price: '0.00',
    initialPrice: '0.00',
  },
  {
    id: generateShortId(),
    type: PRICING_TYPES.fixed,
    monthsDuration: 12,
    signUpFee: null,
    price: '0.00',
    initialPrice: '0.00',
  },
  {
    id: generateShortId(),
    type: PRICING_TYPES.fixed,
    monthsDuration: 24,
    signUpFee: null,
    price: '0.00',
    initialPrice: '0.00',
  },
  {
    id: generateShortId(),
    type: PRICING_TYPES.fixed,
    monthsDuration: 36,
    signUpFee: null,
    price: '0.00',
    initialPrice: '0.00',
  },
];

export const procurementFields = [
  'sourcingType',
  'orderDate',
  'dealer',
  'agreedCustomsDate',
  'estimatedCustomsDate',
  'supplierOrderId',
  'agreedPurchasePrice',
  'customsEntryDate',
  'plannedDownpaymentDate',
  'vehicleOwnership',
  'financingType',
  'financingProvider',
  'retailPrice',
  'retailPriceBeforeTax',
  'vat',
  'extras',
  'extrasPrice',
  'specialClassificationFee',
  'classificationCosts',
  'discountPercentage',
  'discountWithoutVat',
  'finalPurchasePrice',
  'kilometersAtPurchase',
  'leaseMonthlyInstallment',
  'buyOutPrice',
  'buyOutMonths',
  'licenseIssuanceDate',
  'insuranceProvider',
  'insuranceDate',
  'insuranceRenewalDate',
  'vehiclePurchaseDate',
  'leaseStartDate',
  'plannedReceiptDate',
  'receiptDate',
  'defleetedDate',
  'cancelledDate',
  'cancelledDefleetedReason',
  'transferCost',
  'insuranceCancellationDate',
  'defleetPriority',
  'monthOfDefleet',
  'delayReason',
];
export const propertiesFields = [
  'transmission',
  'color',
  'roofColor',
  'interiorColor',
  'engine',
  'fuelType',
  'emissions',
  'tireSize',
];
export const invoiceDetailsFields = [
  'invoiceNumber',
  'netPrice',
  'registrationTax',
  'invoiceDetailsVat', // vat
  'transferFee',
  'plateReleaseFee',
];
export const topLevelFields = ['plate', 'vin', 'condition', 'tenant'];

export const VEHICLE_HISTORY_CHANGES_DEFAULT_PAGE_SIZE = 500;

export const DEFLEETED_PRIORITIES = [
  { label: 'No Priority', value: '0' },
  { label: 'Low Priority', value: '1' },
  { label: 'High Priority', value: '2' },
];

export const DELAY_REASONS = [
  { label: 'Payment Approval Delay', value: 'Payment Approval Delay' },
  { label: 'No Booking', value: 'No Booking' },
  { label: 'Dealer Delay', value: 'Dealer Delay' },
];
